module.exports = __webpack_public_path__ + "img/bell-alt-ring.6d8bdabc.svg";